import { ProjectVersion } from './version.model';

export const PROJECT_VERSION = new ProjectVersion('1.16.0', '11/04/2025');
